import axios from 'axios';

// 开发环境
axios.setConfig = function (config) {
	axios.defaults.baseURL = config.BASE_URL;
	axios.defaults.timeout = config.AJAX_TIMEOUT;
	// axios.defaults.withCredentials = true; // 表示跨域请求时是否需要使用凭证,也可自动把后台set的cookie存起来
};

export default axios;



// WEBPACK FOOTER //
// ./main/common/ajax/config.js